import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AccordionComponent implements OnInit {
  @Input() list: any;
  collapsedHeight = '56px';
  expandedHeight = '56px';

  constructor() {}

  ngOnInit() {}
}
